"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegacySlice = exports.LegacySlice = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const Group_1 = require("../Group");
const NestableWidget_1 = require("../nestable/NestableWidget");
exports.LegacySlice = t.union([NestableWidget_1.NestableWidget, Group_1.NestedGroup]);
function isLegacySlice(slice) {
    return slice.type !== "Slice" && slice.type !== "SharedSlice";
}
exports.isLegacySlice = isLegacySlice;
